import { Tooltip, Typography, IconButton } from '@mui/material'
import isEqual from 'lodash/isEqual'
import SaveIcon from '@mui/icons-material/Save'
import { User } from 'types'
import { sameIds } from 'utils/ids'

const SaveNewOnboardingTeam = ({
  newTeam,
  currTeam,
  onSave,
}: {
  newTeam: User[]
  currTeam: User[]
  onSave: () => void
}) => {
  const dirty = !sameIds(newTeam, currTeam)
  return dirty ? (
    <Tooltip title={<Typography>Save Assignees</Typography>}>
      <IconButton onClick={onSave} className="highlight-assignee-save">
        <SaveIcon
          sx={{ fontSize: 28, color: !isEqual(newTeam, currTeam || []) ? 'text.highlight' : 'text.secondary' }}
        />
      </IconButton>
    </Tooltip>
  ) : null
}

export default SaveNewOnboardingTeam
